import {
  customerMarketShopfrontJobsApi,
  marketApi
} from '@envato/foundation-types'

import {
  ActionTypes as FeaturedActionTypes,
  IFeaturedPageSeoMetaData,
  TypeKeys as FeaturedTypeKeys
} from '../actions/featurePage'

export interface IState {
  readonly featuredItems?: customerMarketShopfrontJobsApi.IBaseResult
  readonly featuredAuthors?: customerMarketShopfrontJobsApi.IFeaturedAuthorsResult
  readonly metadata?: IFeaturedPageSeoMetaData
  readonly isLoading: boolean
}

const initialState: IState = {
  featuredItems: undefined,
  featuredAuthors: undefined,
  isLoading: false
}

export const reducer = (
  state = initialState,
  action: FeaturedActionTypes
): IState => {
  switch (action.type) {
    case FeaturedTypeKeys.GET_FEATURED_PAGE_API_REQUEST:
      return {
        ...state,
        featuredItems: undefined,
        isLoading: true
      }

    case FeaturedTypeKeys.GET_FEATURED_PAGE_API_SUCCESS:
      const featuredItems = action.payload.featured_items
      const featuredAuthors = action.payload.featured_authors
      const metadata = action.payload.metadata

      return {
        featuredItems,
        featuredAuthors,
        metadata,
        isLoading: false
      }

    case FeaturedTypeKeys.GET_FEATURED_PAGE_API_FAIL:
      return {
        ...state,
        isLoading: false
      }

    default:
      return state
  }
}
